/* Protected evidence stays in memory; this viewer never requests or exports data. */
(() => {
  window.KoBReviewViewer = (root) => {
    const dialog = root.querySelector('[data-cpr-zoom]');
    const stage = dialog.querySelector('[data-cpr-view-stage]');
    const image = dialog.querySelector('[data-cpr-view-image]');
    const tabs = dialog.querySelector('[data-cpr-view-tabs]');
    const title = dialog.querySelector('[data-cpr-view-title]');
    const meta = dialog.querySelector('[data-cpr-view-meta]');
    const output = dialog.querySelector('[data-cpr-view-percent]');
    const views = new WeakMap();
    let panels = [], panel = null, state = null, fit = 1, previousOverflow = '';
    let gesture = null;
    const pointers = new Map();
    const get = (item) => {
      if (!views.has(item)) views.set(item, { zoom: 1, rotation: 0, x: 0, y: 0 });
      return views.get(item);
    };
    const dimensions = () => {
      const source = panel?.querySelector('img');
      const rotated = state?.rotation % 180 !== 0;
      return { source, width: rotated ? source?.naturalHeight : source?.naturalWidth,
        height: rotated ? source?.naturalWidth : source?.naturalHeight };
    };
    function draw() {
      if (!state || !panel || !dialog.open) return;
      const { source, width, height } = dimensions();
      if (!source?.naturalWidth || !stage.clientWidth || !stage.clientHeight) return;
      fit = Math.min((stage.clientWidth - 24) / width, (stage.clientHeight - 24) / height);
      const maxX = Math.max(0, (width * fit * state.zoom - stage.clientWidth) / 2 + 12);
      const maxY = Math.max(0, (height * fit * state.zoom - stage.clientHeight) / 2 + 12);
      state.x = Math.max(-maxX, Math.min(maxX, state.x)); state.y = Math.max(-maxY, Math.min(maxY, state.y));
      image.style.width = `${source.naturalWidth * fit}px`;
      image.style.height = `${source.naturalHeight * fit}px`;
      image.style.transform = `translate(-50%,-50%) translate(${state.x}px,${state.y}px) rotate(${state.rotation}deg) scale(${state.zoom})`;
      stage.dataset.zoomed = state.zoom > 1 ? 'true' : 'false';
      output.textContent = `${Math.round(state.zoom * 100)}%`;
      dialog.querySelector('[data-cpr-view-out]').disabled = state.zoom <= 1;
      dialog.querySelector('[data-cpr-view-in]').disabled = state.zoom >= 16;
    }
    function switchTo(item) {
      panel = item; state = get(item); pointers.clear(); gesture = null;
      const original = item.querySelector('img');
      image.src = original.src; image.alt = original.alt;
      title.textContent = item.dataset.photoTitle || original.alt;
      meta.textContent = item.dataset.photoMeta || '';
      [...tabs.children].forEach((button, index) => {
        button.setAttribute('aria-pressed', String(panels[index] === item));
      });
      draw();
    }
    function open(item) {
      if (!item?.querySelector('img')) return;
      panels = [...root.querySelectorAll('[data-cpr-photo]')].filter((p) => p.querySelector('img'));
      tabs.replaceChildren(...panels.map((p) => {
        const button = document.createElement('button'); button.type = 'button';
        button.textContent = p.dataset.photoTab || p.dataset.photoTitle || p.querySelector('h3').textContent;
        button.addEventListener('click', () => switchTo(p)); return button;
      }));
      tabs.hidden = panels.length < 2;
      if (!dialog.open) { previousOverflow = document.documentElement.style.overflow; dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
      switchTo(item);
    }
    function zoom(value, point = null) {
      if (!state) return;
      const next = Math.max(1, Math.min(16, value));
      if (point) { const ratio = next / state.zoom; state.x = point.x - (point.x - state.x) * ratio; state.y = point.y - (point.y - state.y) * ratio; }
      state.zoom = next; draw();
    }
    dialog.addEventListener('click', (event) => {
      const button = event.target.closest('button'); if (!button || !state) return;
      if (button.hasAttribute('data-cpr-view-in')) zoom(state.zoom * 1.5);
      if (button.hasAttribute('data-cpr-view-out')) zoom(state.zoom / 1.5);
      if (button.hasAttribute('data-cpr-view-fit')) { Object.assign(state, { zoom: 1, x: 0, y: 0 }); draw(); }
      if (button.hasAttribute('data-cpr-view-original')) zoom(1 / fit);
      if (button.hasAttribute('data-cpr-view-rotate')) { state.rotation = (state.rotation + 90) % 360; state.x = state.y = 0; draw(); }
    });
    stage.addEventListener('wheel', (event) => {
      if (!dialog.open) return; event.preventDefault(); const rect = stage.getBoundingClientRect();
      zoom(state.zoom * (event.deltaY < 0 ? 1.15 : 1 / 1.15), { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 });
    }, { passive: false });
    stage.addEventListener('dblclick', (event) => {
      const rect = stage.getBoundingClientRect();
      zoom(state.zoom > 1 ? 1 : 3, { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 });
    });
    function seedGesture() {
      const points = [...pointers.values()];
      if (points.length >= 2) {
        const [a, b] = points; gesture = { distance: Math.hypot(b.x - a.x, b.y - a.y),
          midpoint: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, zoom: state.zoom, x: state.x, y: state.y };
      } else gesture = points.length ? { point: points[0], x: state.x, y: state.y } : null;
    }
    stage.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || !state) return; event.preventDefault();
      stage.setPointerCapture(event.pointerId); pointers.set(event.pointerId, { x: event.clientX, y: event.clientY }); seedGesture();
    });
    stage.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId) || !gesture) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY }); const points = [...pointers.values()];
      if (points.length >= 2 && gesture.distance) {
        const [a, b] = points; const next = Math.max(1, Math.min(16, gesture.zoom * Math.hypot(b.x - a.x, b.y - a.y) / gesture.distance));
        const rect = stage.getBoundingClientRect(); const mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        const origin = { x: gesture.midpoint.x - rect.left - rect.width / 2, y: gesture.midpoint.y - rect.top - rect.height / 2 };
        const ratio = next / gesture.zoom;
        state.x = origin.x - (origin.x - gesture.x) * ratio + mid.x - gesture.midpoint.x;
        state.y = origin.y - (origin.y - gesture.y) * ratio + mid.y - gesture.midpoint.y; state.zoom = next;
      } else if (gesture.point) {
        state.x = gesture.x + event.clientX - gesture.point.x; state.y = gesture.y + event.clientY - gesture.point.y;
      }
      draw();
    });
    const release = (event) => { pointers.delete(event.pointerId); if (state) seedGesture(); };
    stage.addEventListener('pointerup', release); stage.addEventListener('pointercancel', release); stage.addEventListener('lostpointercapture', release);
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      pointers.clear(); gesture = null; image.removeAttribute('src'); panel = null; state = null;
    });
    dialog.addEventListener('keydown', (event) => {
      if (!state || !['ArrowLeft','ArrowRight'].includes(event.key) || panels.length < 2 || event.target.tagName === 'BUTTON') return;
      event.preventDefault(); const index = panels.indexOf(panel) + (event.key === 'ArrowLeft' ? -1 : 1);
      if (panels[index]) switchTo(panels[index]);
    });
    const observer = new ResizeObserver(draw); observer.observe(stage);
    window.addEventListener('pagehide', () => { observer.disconnect(); if (dialog.open) dialog.close(); });
    return { open, close: () => { if (dialog.open) dialog.close(); },
      rotateInline(item) {
        const original = item.querySelector('img'); if (!original) return;
        const view = get(item); view.rotation = (view.rotation + 90) % 360;
        const visual = item.querySelector('[data-cpr-visual]'); const swapped = view.rotation % 180 !== 0;
        const ratio = Math.min((visual.clientWidth - 24) / (swapped ? original.naturalHeight : original.naturalWidth), (visual.clientHeight - 24) / (swapped ? original.naturalWidth : original.naturalHeight));
        original.style.width = `${original.naturalWidth * ratio}px`; original.style.height = `${original.naturalHeight * ratio}px`;
        original.style.maxWidth = original.style.maxHeight = 'none'; original.style.transform = `rotate(${view.rotation}deg)`;
      } };
  };
})();
